module.exports = __webpack_public_path__ + "files/e74e86d3dfe9206e90494d50b439632a.png";